export const CONSTANTS = {
  API_URL: process.env.NEXT_PUBLIC_API_URL!,
  APP_URL: "https://sakanihomes.com",
  UAE_COORDINATES: [55.2708, 25.2048] as [number, number],
  IS_PRODUCTION: process.env.NEXT_PUBLIC_APP_ENV == "production",
  GTM_ID: process.env.NEXT_PUBLIC_GTM_ID,
  NAME: {
    en: "Sakani Homes",
    ar: "منازل سكني",
  },
  UAE: {
    en: "United Arab Emirates",
    ar: "الإمارات العربية المتحدة",
  },
  EMIRATES: [
    "dubai",
    "umm-al-quwain",
    "ras-al-khaimah",
    "sharjah",
    "abu-dhabi",
    "ajman",
  ],
};
